import React, { useEffect } from "react";
import { SidebarMenuTabs as BaseSidebarMenuTabs } from "../../Common";
import { TAB } from "../constants";
export default function SidebarMenuTabs(props) {
    useEffect(() => {
        props.onChangeTab && props.onChangeTab(TAB.DOCUMENTS);
    }, [props.projectId]);
    return (React.createElement(BaseSidebarMenuTabs, { defaultHash: props.defaultHash, productName: props.productName, tabs: props.tabs, tabKey: props.tabKey, onChangeTab: props.onChangeTab, onExpandedChanged: props.onExpandedChanged, expandedMenu: props.expandedMenu, rows: props.rows }));
}
SidebarMenuTabs.defaultProps = {
    rows: 1
};
